import React, { useState, useEffect } from 'react';
import { Phone } from 'lucide-react';
import { Button } from './ui/button';

const StickyCallButton = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.pageYOffset > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  return (
    <div className="fixed bottom-6 right-6 z-50">
      {isVisible && (
        <a href="tel:3653363364">
          <Button 
            className="bg-emerald-600 hover:bg-emerald-700 text-white rounded-full w-16 h-16 shadow-2xl hover:shadow-3xl transition-all duration-300 flex items-center justify-center animate-bounce"
            aria-label="Call us now"
          >
            <Phone className="w-7 h-7" />
          </Button>
        </a>
      )}
    </div>
  );
};

export default StickyCallButton;